import { useCallback } from "react";

import { deleteLayerFeatures } from "fond/project/redux";
import { dismissBaseDataTask, failBaseDataTask, startBaseDataTask } from "fond/redux/baseDataTasks";
import { useAppDispatch } from "fond/utils/hooks";

import { BASE_DATA_LAYER_IDS, BaseDataLayerKey } from "../layers";

import { useClearBoundary } from "./useBoundary";

/** Return a callback that deletes every planner layer of a base data row (or the boundary), as a task of that row. */
export const useDeleteBaseData = (): ((key: BaseDataLayerKey) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const clearBoundary = useClearBoundary();

  return useCallback(
    async (key: BaseDataLayerKey) => {
      dispatch(startBaseDataTask({ key, source: "delete", keys: [key], stage: "deleting" }));
      try {
        if (key === "boundary") {
          await clearBoundary();
        } else {
          await dispatch(deleteLayerFeatures(BASE_DATA_LAYER_IDS[key], key));
        }
      } catch {
        dispatch(failBaseDataTask({ key }));
        return;
      }
      dispatch(dismissBaseDataTask(key));
    },
    [clearBoundary, dispatch]
  );
};
